// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"8af01f99","369":"5be03891","409":"4dd584e7","687":"5cc28370","761":"dcf0d83c"}[chunkId] + ".chunk.js";
};